const URL = window.location.origin;

const lang = sessionStorage.getItem('raas-language') || 'es';

export function checkDomain() {
    return window.location.href.includes('localhost');
}

const navigateInformacional = (destiny: string) => {
    const isLocal = checkDomain();
    const pathname = '/' + lang + destiny;
    isLocal
        ? window.location.href = URL + pathname
        : window.location.pathname = pathname;
}

const navigateTransactional = (destiny: string) => {
    const isLocal = checkDomain();
    const pathname = '/app' + destiny;
    isLocal
        ? window.location.href = URL + pathname
        : window.location.pathname = pathname;
}
export {
    navigateInformacional,
    navigateTransactional
}